/* ============================================================
   MES MÉMOIRES — pages.js
   Navigation et footer communs à toutes les pages légales
   ============================================================ */

'use strict';

// ── NAV injection ─────────────────────────────────────────────
(function injectNav() {
  const nav = document.getElementById('nav');
  if (!nav) return;

  nav.innerHTML = `
    <a href="/" class="nav__logo">
      <img src="${(window.MEMOIRES_ASSETS && window.MEMOIRES_ASSETS.logo) || '/assets/img/logo-mm.png'}" alt="Mes Mémoires" class="nav__logo-img">
      <span class="nav__logo-text">Mes Mémoires</span>
    </a>
    <button class="nav__toggle" id="navToggle" aria-label="Ouvrir le menu">
      <span></span><span></span><span></span>
    </button>
    <ul class="nav__links" id="navLinks">
      <li><a href="/#concept"         class="nav__link">Concept</a></li>
      <li><a href="/pages/collections"              class="nav__link">Collections</a></li>
      <li><a href="/#carte-cadeau"                  class="nav__link">E-carte cadeau</a></li>
      <li><a href="/pages/creations-personnalisees" class="nav__link">Créations personnalisées</a></li>
      <li><a href="/pages/pourquoi-nos-creations-sont-uniques" class="nav__link">Pourquoi uniques</a></li>
      <li><a href="/pages/conciergerie"             class="nav__link">Conciergerie</a></li>
      <li><a href="/pages/audio"                       class="nav__link">Audio</a></li>
      <li><a href="/pages/l-histoire"               class="nav__link">L'Histoire</a></li>
      <li><a href="/cart"                           class="nav__link nav__cart" aria-label="Voir le panier">Panier</a></li>
      <li><a href="/pages/collections"              class="btn btn--gold btn--sm btn--3d nav__cta">Commander →</a></li>
    </ul>
  `;

  // Sticky scroll
  const onScroll = () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  nav.classList.add('scrolled'); // Toujours visible sur pages internes

  // Hamburger
  const toggle = document.getElementById('navToggle');
  const links  = document.getElementById('navLinks');
  if (!toggle || !links) return;
  if (toggle.dataset.navBound === 'true') return;
  toggle.dataset.navBound = 'true';
  toggle.setAttribute('aria-expanded', 'false');
  toggle.addEventListener('click', () => {
    const open = links.classList.toggle('open');
    toggle.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  links.querySelectorAll('a').forEach(l => {
    l.addEventListener('click', () => {
      links.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
})();

// ── FOOTER injection ──────────────────────────────────────────
(function injectFooter() {
  const footer = document.getElementById('footer');
  if (!footer) return;

  footer.innerHTML = `
    <div class="footer__top">
      <div class="footer__brand">
        <img src="${(window.MEMOIRES_ASSETS && window.MEMOIRES_ASSETS.logo) || '/assets/img/logo-mm.png'}" alt="Logo Mes Mémoires" class="footer__logo-img">
        <p class="footer__logo">Mes Mémoires</p>
        <p class="footer__tagline">Maison de Correspondance Immersive</p>
        <p class="footer__desc">Donnons vie à vos histoires à travers des livres de correspondance uniques et authentiques, transmis aux générations futures.</p>
        <a href="https://www.instagram.com/mes_memoires?igsh=N3ljODAwZjhoanlr" target="_blank" rel="noopener" class="footer__social-link">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
            <rect x="2" y="2" width="20" height="20" rx="5" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="4" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
            <circle cx="17.5" cy="6.5" r="1.2" fill="#c9a84c"/>
          </svg>
          @mes_memoires
        </a>
        <a href="https://www.tiktok.com/@mes_memoires?_r=1&_t=ZN-96x9gpKa1Q6" target="_blank" rel="noopener" class="footer__social-link footer__social-link--tiktok" aria-label="TikTok Mes Memoires">TikTok</a>
      </div>
      <div class="footer__links-grid">
<div class="footer__col">
        <h4 class="footer__col-title">Navigation</h4>
        <ul class="footer__links">
          <li><a href="/">Accueil</a></li>
          <li><a href="/#concept">Le concept</a></li>
          <li><a href="/pages/creations-personnalisees#accompagnement-editorial">Livre personnalisé</a></li>
          <li><a href="/pages/collections">Nos Collections</a></li>
          <li><a href="/pages/pourquoi-nos-creations-sont-uniques">Pourquoi uniques</a></li>
          <li><a href="/pages/conciergerie">Conciergerie</a></li>
          <li><a href="/#correspondances">Correspondances</a></li>
          <li><a href="/pages/audio">Audio exemple</a></li>
          <li><a href="/pages/l-histoire">L'Histoire</a></li>
        </ul>
      </div>
<div class="footer__col">
        <h4 class="footer__col-title">Informations</h4>
        <ul class="footer__links">
          <li><a href="/pages/mentions-legales">Mentions légales</a></li>
          <li><a href="/pages/conditions-generales-de-vente">Conditions générales de vente</a></li>
          <li><a href="/pages/conditions-generales-d-utilisation">Conditions générales d'utilisation</a></li>
          <li><a href="/pages/politique-de-confidentialite">Politique de confidentialité</a></li>
          <li><a href="/pages/politique-de-remboursement">Politique de remboursement</a></li>
          <li><a href="/pages/aide">Aide &amp; FAQ</a></li>
        </ul>
      </div>
<div class="footer__col">
        <h4 class="footer__col-title">Contact</h4>
        <ul class="footer__links">
          <li><a href="mailto:contact@mesmemoires.fr">contact@mesmemoires.fr</a></li>
          <li><a href="mailto:commande@mesmemoires.fr">commande@mesmemoires.fr</a></li>
          <li><a href="mailto:bonjour@mesmemoires.fr">bonjour@mesmemoires.fr</a></li>
          <li><a href="mailto:sav@mesmemoires.fr">sav@mesmemoires.fr</a></li>
          <li><a href="mailto:partenariat@mesmemoires.fr">partenariat@mesmemoires.fr</a></li>
        </ul>
      </div>
</div>
    </div>
    <div class="footer__divider"></div>
    <div class="footer__bottom">
      <p class="footer__price-note">Tous les prix sont indiqués en euros, toutes taxes comprises (TVA incluse). Livraison calculée au moment de la commande.</p>
      <p>© 2026 Mes Mémoires — Tous droits réservés</p>
      <p class="footer__made">Maison de Correspondance Immersive · France 🇫🇷</p>
    </div>
  `;
})();

// ── PAGE FADE IN ──────────────────────────────────────────────
(function initPageFade() {
  const showPage = () => { document.body.style.opacity = '1'; };
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.4s ease';
  window.addEventListener('load', showPage, { once: true });
  document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(showPage), { once: true });
  window.setTimeout(showPage, 900);
  if (document.readyState !== 'loading') requestAnimationFrame(showPage);
})();

// Complements hard-coded page navs and keeps product buttons on the direct cart path.
(function initSharedCartFlow() {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function productHandleFromUrl(url) {
    try {
      const parts = new URL(url, window.location.origin).pathname.split('/').filter(Boolean);
      const index = parts.indexOf('products');
      return index !== -1 ? parts[index + 1] : '';
    } catch (error) {
      return '';
    }
  }

  const fixedPaidVariantIds = {
    'mes-memoires-dentrepreneur-tropical': 40068106387644,
    'mes-memoires-dentrepreneur-marbre': 40068099342524,
    'mes-memoires-de-grand-pere-tropical': 40068134240444,
    'mes-memoires-de-grand-pere-marbre': 40068131356860,
    'mes-memoires-de-grand-mere-tropical': 40068127064252,
    'mes-memoires-de-grand-mere-marbre': 40068120281276,
    'mes-memoires-de-papa-tropical': 40068157472956,
    'mes-memoires-de-papa-marbre': 40068155211964,
    'mes-memoires-de-maman-tropical-rose': 40068151771324,
    'mes-memoires-de-maman-tournesols': 40068145184956,
    'mes-memoires-de-maman-tropical-perroquets': 40068137844924,
    'mes-memoires-de-maman-jungle': 40068137844924
  };

  const canonicalProductHandles = {
    'mes-memoires-de-maman-jungle': 'mes-memoires-de-maman-tropical-perroquets'
  };

  function showCartConfirmation(item) {
    if (!window.MesMemoiresCartNotice) {
      window.MesMemoiresCartNotice = (function() {
        let shell;
        function ensureShell() {
          if (shell) return shell;
          shell = document.createElement('div');
          shell.className = 'mm-cart-confirmation';
          shell.hidden = true;
          shell.innerHTML = [
            '<div class="mm-cart-confirmation__backdrop" data-mm-cart-close></div>',
            '<section class="mm-cart-confirmation__panel" role="dialog" aria-modal="true" aria-labelledby="mm-cart-confirmation-title">',
            '<button class="mm-cart-confirmation__close" type="button" data-mm-cart-close aria-label="Fermer">×</button>',
            '<p class="mm-cart-confirmation__kicker">Panier</p>',
            '<h2 id="mm-cart-confirmation-title">Produit ajouté au panier</h2>',
            '<p class="mm-cart-confirmation__item" data-mm-cart-item></p>',
            '<div class="mm-cart-confirmation__actions">',
            '<button class="btn btn--outline btn--3d" type="button" data-mm-cart-close>Continuer mes achats</button>',
            '<a class="btn btn--gold btn--3d" href="/cart">Voir le panier</a>',
            '</div>',
            '</section>'
          ].join('');
          shell.addEventListener('click', function(event) {
            if (event.target.closest('[data-mm-cart-close]')) {
              shell.hidden = true;
            }
          });
          document.body.appendChild(shell);
          return shell;
        }
        return {
          show: function(item) {
            const node = ensureShell();
            const label = node.querySelector('[data-mm-cart-item]');
            const title = item && (item.product_title || item.title);
            label.textContent = title ? title : 'Votre sélection a bien été ajoutée.';
            node.hidden = false;
            const continueButton = node.querySelector('[data-mm-cart-close]');
            if (continueButton) continueButton.focus({ preventScroll: true });
          }
        };
      })();
    }
    window.MesMemoiresCartNotice.show(item || null);
  }
  window.MesMemoiresShowCartConfirmation = showCartConfirmation;

  function selectedFormatFromUrl(url) {
    try {
      return new URL(url, window.location.origin).searchParams.get('format') || '';
    } catch (error) {
      return '';
    }
  }

  function variantMatchesFormat(variant, format) {
    if (!format) return true;
    const haystack = normalize([variant.title, variant.option1, variant.option2, variant.option3].join(' '));
    return normalize(format).split(' ').filter(Boolean).every(function(part) {
      if (part === 'duo') return haystack.includes('duo') || haystack.includes('pack');
      if (part === 'broche') return haystack.includes('broche') || haystack.includes('broch');
      if (part === 'spirale') return haystack.includes('spirale') || haystack.includes('wire');
      return haystack.includes(part);
    });
  }

  function findVariant(product, format) {
    const allVariants = product && Array.isArray(product.variants) ? product.variants : [];
    const fixedVariantId = fixedPaidVariantIds[product && product.handle];
    if (fixedVariantId) {
      return allVariants.find(function(variant) {
        return String(variant.id) === String(fixedVariantId);
      }) || { id: fixedVariantId };
    }
    const variants = allVariants.filter(function(variant) {
      return variant.available;
    });
    if (!variants.length) return null;
    return variants.find(function(variant) {
      return variantMatchesFormat(variant, format);
    }) || variants[0];
  }

  function enhanceNavLinks() {
    document.querySelectorAll('.nav__links').forEach(function(links) {
      if (!links.querySelector('a[href="/#carte-cadeau"]')) {
        const giftItem = document.createElement('li');
        giftItem.innerHTML = '<a href="/#carte-cadeau" class="nav__link">E-carte cadeau</a>';
        const collections = Array.from(links.querySelectorAll('a')).find(function(link) {
          return /collections/i.test(link.getAttribute('href') || '') && /collections/i.test(link.textContent || '');
        });
        if (collections && collections.parentElement) collections.parentElement.insertAdjacentElement('afterend', giftItem);
        else links.insertBefore(giftItem, links.firstChild);
      }

      if (!links.querySelector('a[href="/cart"]')) {
        const cartItem = document.createElement('li');
        cartItem.innerHTML = '<a href="/cart" class="nav__link nav__cart" aria-label="Voir le panier">Panier</a>';
        const cta = links.querySelector('.nav__cta');
        if (cta && cta.parentElement) cta.parentElement.insertAdjacentElement('beforebegin', cartItem);
        else links.appendChild(cartItem);
      }
    });
  }

  function bindDirectCartLinks() {
    document.addEventListener('click', function(event) {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link || !normalize(link.textContent).includes('ajouter au panier')) return;
      const href = link.getAttribute('href') || '';
      const handle = productHandleFromUrl(href);
      if (!handle) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      const originalText = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Ajout au panier...';

      const fetchHandle = canonicalProductHandles[handle] || handle;
      fetch('/products/' + encodeURIComponent(fetchHandle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(response) {
          if (!response.ok) throw new Error('product-not-found');
          return response.json();
        })
        .then(function(product) {
          const variant = findVariant(product, selectedFormatFromUrl(href));
          if (!variant) throw new Error('variant-not-found');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(variant.id), quantity: 1 })
          });
        })
        .then(function(response) {
          if (!response.ok) throw new Error('cart-add-failed');
          return response.json();
        })
        .then(function(item) {
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
          showCartConfirmation(item);
        })
        .catch(function() {
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
          window.location.href = href;
        });
    });
  }

  function bindAjaxCartForms() {
    document.querySelectorAll('form').forEach(function(form) {
      const action = form.getAttribute('action') || '';
      if (form.dataset.ajaxCartBound === 'true') return;
      if (!/\/cart\/add/i.test(action)) return;
      if (form.classList.contains('cart-form')) return;
      form.dataset.ajaxCartBound = 'true';

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        const submitter = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
        const originalText = submitter && 'textContent' in submitter ? submitter.textContent : '';
        if (submitter) {
          submitter.setAttribute('aria-busy', 'true');
          if ('textContent' in submitter) submitter.textContent = 'Ajout au panier...';
        }

        const body = new FormData(form);
        body.delete('return_to');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        })
          .then(function(response) {
            if (!response.ok) throw new Error('cart-add-failed');
            return response.json();
          })
          .then(function(item) {
            if (submitter) {
              submitter.removeAttribute('aria-busy');
              if ('textContent' in submitter && originalText) submitter.textContent = originalText;
            }
            showCartConfirmation(item);
          })
          .catch(function() {
            form.submit();
          });
      });
    });
  }

  function bindCartUpdateForm() {
    const form = document.querySelector('.cart-form');
    if (!form || form.dataset.cartUpdateBound === 'true') return;
    form.dataset.cartUpdateBound = 'true';
    const updateButton = form.querySelector('[data-cart-update-button], button[name="update"]');
    const updateButtonText = updateButton ? updateButton.textContent : '';
    let cartUpdateTimer = null;

    function updatesPayload() {
      return Array.from(form.querySelectorAll('input[name="updates[]"]')).map(function(input) {
        const value = Number(input.value);
        if (!Number.isFinite(value) || value < 0) return 0;
        return Math.floor(value);
      });
    }

    function updateCart() {
      if (updateButton) {
        updateButton.setAttribute('aria-busy', 'true');
        updateButton.textContent = 'Mise à jour...';
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updatesPayload() })
      }).then(function(response) {
        if (!response.ok) throw new Error('cart-update-failed');
        return response.json();
      });
    }

    function refreshCart() {
      return updateCart()
        .then(function() {
          window.location.href = '/cart';
        })
        .catch(function() {
          if (updateButton) {
            updateButton.removeAttribute('aria-busy');
            updateButton.textContent = updateButtonText;
          }
        });
    }

    function scheduleCartRefresh() {
      window.clearTimeout(cartUpdateTimer);
      cartUpdateTimer = window.setTimeout(refreshCart, 650);
    }

    form.querySelectorAll('input[name="updates[]"]').forEach(function(input) {
      input.addEventListener('input', function() {
        if (input.value === '') return;
        scheduleCartRefresh();
      });
      input.addEventListener('change', function() {
        if (input.value === '') input.value = '0';
        scheduleCartRefresh();
      });
      input.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (form.requestSubmit && updateButton) form.requestSubmit(updateButton);
          else refreshCart();
        }
      });
    });

    form.addEventListener('submit', function(event) {
      const submitter = event.submitter;
      const isCheckout = submitter && submitter.name === 'checkout';
      event.preventDefault();
      updateCart()
        .then(function() {
          window.location.href = isCheckout ? '/checkout' : '/cart';
        })
        .catch(function() {
          if (updateButton) updateButton.removeAttribute('aria-busy');
          form.submit();
        });
    });
  }

  function syncFormatSelectors() {
    document.querySelectorAll('[data-format-selector]').forEach(function(zone) {
      const select = zone.querySelector('.product-format-select');
      if (!select) return;
      const product = zone.closest('.multi-format-product, .amp-product, .coll-book');
      const buy = product ? product.querySelector('.product-buy-link, .amp-buy a, .coll-buy a') : null;
      const price = product ? product.querySelector('.product-current-price, .amp-current-price, .coll-price') : null;
      const details = zone.querySelectorAll('[data-format-detail]');
      function applySelection() {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        if (buy && option.dataset.cartUrl) buy.setAttribute('href', option.dataset.cartUrl);
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        details.forEach(function(detail) {
          detail.classList.toggle('is-active', detail.dataset.formatDetail === option.value);
        });
      }
      select.addEventListener('change', applySelection);
      applySelection();
    });
  }

  ready(function() {
    enhanceNavLinks();
    syncFormatSelectors();
    bindDirectCartLinks();
    bindAjaxCartForms();
    bindCartUpdateForm();
  });
})();
